import React from "react";
import { MTableToolbar } from "@material-table/core";
import PropertiesToolbar, { OrgOption } from "./properties-toolbar";

type PropertiesMTableToolbarFilterProps = {
  showArchived: boolean;
  onShowArchivedChange: (show: boolean) => void;
  organizationId: string | null;
  onOrganizationIdChange: (id: string | null) => void;
  organizationOptions: OrgOption[];
};

type Props = {
  tableToolbarProps: React.ComponentProps<typeof MTableToolbar>;
  filterProps: PropertiesMTableToolbarFilterProps;
};

const PropertiesMTableToolbar: React.FC<Props> = ({ tableToolbarProps, filterProps }) => (
  <div>
    <MTableToolbar {...tableToolbarProps} />
    <PropertiesToolbar {...filterProps} />
  </div>
);

export default PropertiesMTableToolbar;
